
import React from "react";
import Layout from "@/components/Layout";

const Terms = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8 text-lawyer-primary">Termos e Condições</h1>
          
          <div className="prose prose-lg max-w-none">
            <p>
              Ao acessar e utilizar a plataforma LexPrompt, você concorda com estes Termos e Condições ("Termos"). Por favor, leia-os atentamente.
            </p>

            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao utilizar nossos serviços, você concorda em cumprir estes Termos e Condições. Se não concordar com algum aspecto destes termos, não poderá utilizar nossos serviços.
            </p>

            <h2>2. Descrição do Serviço</h2>
            <p>
              A LexPrompt é uma plataforma que oferece prompts otimizados para uso em ferramentas de inteligência artificial, com foco na prática jurídica. Nossos serviços são oferecidos nas modalidades gratuita e premium, com diferentes níveis de acesso e funcionalidades.
            </p>

            <h2>3. Planos de Assinatura e Pagamentos</h2>
            <p>
              3.1. Oferecemos um plano gratuito com acesso limitado a 3 prompts e um plano premium com acesso ilimitado a todos os prompts.
            </p>
            <p>
              3.2. Os valores das assinaturas estão indicados em nossa página de Preços e podem ser alterados mediante aviso prévio de 30 dias.
            </p>
            <p>
              3.3. O pagamento é processado por meio de nosso parceiro Stripe, de acordo com os termos de serviço dessa plataforma.
            </p>
            <p>
              3.4. Assinaturas são cobradas de forma recorrente até que sejam canceladas pelo usuário.
            </p>

            <h2>4. Política de Reembolso</h2>
            <p>
              4.1. Oferecemos reembolso no prazo de 7 dias após a contratação do plano premium, caso o usuário não esteja satisfeito com os serviços.
            </p>
            <p>
              4.2. Solicitações de reembolso devem ser feitas através do email contato@decidedigital.com.br.
            </p>

            <h2>5. Propriedade Intelectual</h2>
            <p>
              5.1. Todo o conteúdo disponibilizado na plataforma LexPrompt, incluindo prompts, textos, gráficos e logotipos, é de propriedade da LexPrompt ou de seus licenciadores e está protegido por leis de direitos autorais.
            </p>
            <p>
              5.2. Os usuários recebem uma licença limitada, não exclusiva e intransferível para utilizar os prompts em suas atividades profissionais.
            </p>
            <p>
              5.3. É expressamente proibida a redistribuição, revenda ou disponibilização dos prompts a terceiros sem autorização prévia.
            </p>

            <h2>6. Responsabilidade do Usuário</h2>
            <p>
              6.1. Os usuários são responsáveis por adaptar e verificar o conteúdo gerado com os prompts para suas necessidades específicas.
            </p>
            <p>
              6.2. A LexPrompt não se responsabiliza pelo uso inadequado dos prompts ou por decisões tomadas com base no conteúdo gerado através deles.
            </p>
            <p>
              6.3. Os usuários devem utilizar os prompts de acordo com as normas éticas e legais da advocacia.
            </p>

            <h2>7. Limitação de Responsabilidade</h2>
            <p>
              7.1. A LexPrompt não garante que os prompts atenderão a todas as necessidades específicas dos usuários ou que funcionarão sem interrupções.
            </p>
            <p>
              7.2. Não nos responsabilizamos por danos diretos, indiretos, incidentais ou consequenciais resultantes do uso ou incapacidade de uso de nossos serviços.
            </p>

            <h2>8. Modificações nos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes Termos a qualquer momento, publicando os termos modificados em nosso site. O uso contínuo dos serviços após tais modificações constitui sua concordância com os novos termos.
            </p>

            <h2>9. Lei Aplicável</h2>
            <p>
              Estes Termos são regidos pelas leis da República Federativa do Brasil.
            </p>

            <p className="mt-8">
              Última atualização: 19 de maio de 2024
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
